import { Box, BoxProps, makeStyles } from '@material-ui/core';
import React from 'react';
import { LoadingBackdrop } from './LoadingBackdrop';

export type LoadingBoxProps = BoxProps & {
    isLoading: boolean
}

export function LoadingBox ({ isLoading, children, ...props}: LoadingBoxProps) {
    const cls = useStyles();

    return (
        <Box className={cls.root} {...props}>
            <React.Fragment>
                { children }

                <LoadingBackdrop isLoading={isLoading} />
            </React.Fragment>
        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative'
    }
}));